import { instance } from "@/apis";
import { useMutation, useQueryClient, InfiniteData } from "@tanstack/react-query";
import type { ChatListResponse } from "@/hooks/services/queries/ai-agent/use-chats-query";

export const useUpdateChatMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      chatId,
      title,
    }: {
      chatId: string;
      title: string;
    }) => {
      return instance
        .put(`/api/df/user/chat/${chatId}`, {"chatTitle": title})
        .then((res) => res.data.data);
    },

    onMutate: async ({ chatId, title }) => {
      // Optimistic Update: 캐시에서 채팅 제목 즉시 업데이트
      const previousChats = queryClient.getQueryData<InfiniteData<ChatListResponse>>(["chats"]);

      if (previousChats?.pages) {
        queryClient.setQueryData<InfiniteData<ChatListResponse>>(["chats"], {
          ...previousChats,
          pages: previousChats.pages.map((page) => ({
            ...page,
            content: page.content.map((chat) =>
              chat.chatId === chatId ? { ...chat, chatTitle: title } : chat
            ),
          })),
        });
      }

      return { previousChats };
    },

    onSuccess: () => {
      // invalidateQueries를 사용하지 않음
      // 다른 스트리밍 중인 채팅방이 사라지는 것을 방지
    },

    onError: (_err, _variables, context) => {
      // 에러 발생 시 이전 상태로 롤백
      if (context?.previousChats) {
        queryClient.setQueryData(["chats"], context.previousChats);
      }
    },
  });
};
